import Image from 'next/image';

import { classNames } from '@/utils/classNames';

import type { SparksMessage } from './SparksConversation';

type SparksMessageBubbleProps = {
    message: SparksMessage;
};

export function SparksMessageBubble({ message }: SparksMessageBubbleProps) {
    const isUser = message.role === 'user';

    return (
        <div
            className={classNames('flex w-full', {
                'justify-end': isUser,
                'justify-start': !isUser
            })}>
            <div className="flex max-w-[85%] gap-2">
                {!isUser && (
                    <div className="mt-1 flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-icoGray-300">
                        <Image
                            src="/images/svg/sparks-avatar.svg"
                            alt="Sparks"
                            width={20}
                            height={20}
                        />
                    </div>
                )}
                <div
                    className={classNames(
                        'whitespace-pre-wrap break-words rounded-xl px-3 py-2 font-GMedium text-xs leading-5 tracking-tight',
                        isUser ? 'bg-icoGray-300 text-icoBlack' : 'bg-white text-icoBlack'
                    )}>
                    {message.content}
                </div>
            </div>
        </div>
    );
}
